var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-wrapper",style:({fontFamily: _vm.$localeLang==='zh' ? '黑体, Arial, sans-serif':'Montserrat, Arial, sans-serif'})},[_c('Header'),_c('div',{staticClass:"main-content"},[_vm._t("default")],2),_c('FooterTwo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }